import { Fragment } from 'react';

/**
 * The brand as it is always written. The lowercase `c` is the whole point.
 */
const BRAND = 'JNcQUOI';

/** Splits on the brand token, keeping it as a capture so the parts can be rebuilt in order. */
const BRAND_PATTERN = /(jncquoi)/gi;

/**
 * Renders text that sits under a CSS `uppercase` without flattening the brand to `JNCQUOI`.
 *
 * `text-transform: uppercase` cannot spare one letter of a word, and the small labels across the app
 * are uppercased in CSS rather than in the copy — so anywhere the brand appears inside one, its `c`
 * was being lost. This restores it by isolating the token in a `normal-case` span and writing it in
 * its canonical form, whatever case the source used.
 *
 * Applied to the string rather than to the copy because these labels are authored in the CMS: a fix
 * that depended on an editor typing `JNcQUOI` in caps would silently regress the first time someone
 * retyped a label, in any of the locales.
 *
 * Only the token is special-cased; the rest of the string is left for the parent's own
 * `text-transform` to handle, so callers keep their existing `uppercase` class.
 */
export function BrandCase({ children }: { children: string }) {
  return (
    <>
      {children.split(BRAND_PATTERN).map((part, index) =>
        part.toLowerCase() === BRAND.toLowerCase() ? (
          <span key={index} className="normal-case">
            {BRAND}
          </span>
        ) : (
          <Fragment key={index}>{part}</Fragment>
        )
      )}
    </>
  );
}
